module.exports = __webpack_public_path__ + "files/98deff620d68a539b0a2b808f5248f6f.png";